import { useEffect, useRef } from 'react'
import {
  BROADCAST_MESSAGE_TYPES,
  getTabId,
  subscribeToBroadcastMessages,
} from 'utils/broadcastChannel'
import { useAuth } from './useAuth'
import { useAuthState } from './useAuthState'

export const useEmailConfirmedBroadcast = () => {
  const { tryStartSession } = useAuth()
  const { isAuthenticated, user } = useAuthState()
  const userRef = useRef(user)
  const tabIdRef = useRef(getTabId())

  userRef.current = user

  useEffect(() => {
    if (!isAuthenticated) {
      return
    }

    return subscribeToBroadcastMessages((data) => {
      if (data?.type !== BROADCAST_MESSAGE_TYPES.EMAIL_CONFIRMED) {
        return
      }

      if (data.tabId === tabIdRef.current) {
        return
      }

      if (userRef.current?.is_email_confirmed === true) {
        return
      }

      tryStartSession()
    })
  }, [isAuthenticated, tryStartSession])
}
